import React from "react";
import DocumentVenteEntity from "./DocumentVenteEntity";

const BonLivraison = () => {
    return <DocumentVenteEntity type="Bon Livraison" title="Bons Livraison" endpoint="BonLivraison" />;
};

export default BonLivraison;
